/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '@siemens/ix-angular';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrl: './feedback-form.component.scss',
  standalone: false,
})
export class FeedbackFormComponent implements OnInit, OnDestroy {
  private readonly formBuilder = inject(FormBuilder);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);
  private readonly userService = inject(UserService);

  @Output() submitted = new EventEmitter<boolean>();
  feedbackInputForm!: FormGroup;
  hasBeenSubmitted = false;

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    // Validator: checks if at least one input field has a value
    const atLeastOneInput: ValidatorFn = (
      control: AbstractControl,
    ): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const formControls = Object.values(formGroup.controls);
      const hasInput = formControls.some((formControl) => !!formControl.value); // Prüft, ob ein Wert vorhanden ist
      return hasInput ? null : {noInput: true}; // Returns an error, if no input is present
    };

    this.feedbackInputForm = this.formBuilder.group(
      {
        changeDataPoints: new FormControl<string>(''),
        changeDescription: new FormControl<string>(''),
        newDataPoints: new FormControl<string>(''),
      },
      {validators: atLeastOneInput},
    );
  }

  async onSubmit() {
    this.hasBeenSubmitted = true;

    if (!this.feedbackInputForm.errors?.['noInput']) {
      await this.userService.submitFeedback(this.feedbackInputForm.value);

      this.submitted.emit(true);
      this.hasBeenSubmitted = false;
      this.feedbackInputForm.reset();

      this.translateService
        .get('feedback.success_msg')
        .subscribe((msg: string) => {
          this.toastService.show({
            message: msg,
            type: 'success',
          });
        });
    }
  }

  ngOnDestroy() {
    this.hasBeenSubmitted = false;
    this.feedbackInputForm.reset();
  }
}
